module.exports = __webpack_public_path__ + "img/manchester-united-logo-icon.16a59bc3.png";